import styled from 'styled-components'

export default styled.section`
  padding: 24px 0px;
  border-radius: 4px;

  .dashed {
    height: 20px;
    font-size: 24px;
    font-weight: bold;
    color: ${ ({ theme }) => theme.colors.black };
    transform: rotate(90deg);
    margin-left: 10px;
  }

  .row-details {
    display: flex;
    flex-direction: row;
    gap: 8px;

    img {
      width: 24px;
      height: 24px;
    }

    img[alt="info"] {
      width: 16px;
      height: 16px;
    }

    span {
      display: flex;
      align-items: center;
    }

    button {
      background-color: transparent;
      border: none;
    }
  }

  .column-details {
    display: flex;
    flex-direction: column;
    justify-content: center;
    gap: 24px;
  }

  .route-dots {
    width: 25%;
  }

  .stop-info {
    display: flex;
    margin-left: 5px;
    min-height: 65px;
    flex-direction: column;
    justify-content: center;
    gap: 15px;

    .row-details {
      align-items: center;
    }
  }

  p {
    margin: unset;
  }

  .text-top {
    font-family: ${ ({ theme }) => theme.fontFamily };
    font-size: 14px; 
    color: ${ ({ theme }) => theme.colors.black };
  }

  .text-bottom {
    font-family: ${ ({ theme }) => theme.fontFamily };
    font-size: 18px;
    color: ${ ({ theme }) => theme.colors.black };
    font-weight: 700;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
    word-break: break-word;
  }

  .not-available {
    color: ${ ({ theme }) => theme.colors.grey };
  }

  .hour {
    min-height: 65px;

    > button {
      background-color: transparent;
      border: none;
    }
  }
    
  .hour-text {
    font-family: ${ ({ theme }) => theme.fontFamily };
    font-size: 14px;
    color: ${ ({ theme }) => theme.colors.black };
    white-space: pre;

    span {
      font-size: 18px;
      font-weight: 700 !important;
    }

    .aprox-prefix {
      font-size: 14px !important;
      font-weight: normal !important;
    }
  }

  @media screen and (max-width: 768px) {
    padding: 22px 10px;
  }
`
